var _style, _g, _g2, _g3, _path, _path2, _g4, _g5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAhsokaLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0al{fill:#588443;}\r\n\t.st1al{fill:#EF791F;}\r\n\t.st2al{fill:#EDE0DC;}\r\n\t.st3al{fill:#E68B4E;}\r\n\t.st4al{fill:#4F4A58;}\r\n\t.st5al{fill:#504A58;}\r\n\t.st6al{fill:#825716;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lag_1_1_"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st0al",
    cx: 150,
    cy: 150.3,
    r: 150
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Lag_2_1_"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Lag_6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1al",
    d: "M155.4,206.2c-1.8,0.2-3.6,0.4-5.4,0.6c-1.6-0.3-3.1-0.6-4.7-0.8c-0.5-45.9-1.1-91.9-1.6-137.8h12.1 C155.7,114.2,155.6,160.2,155.4,206.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2al",
    d: "M154.2,71.8c-1.4,0.4-2.8,0.8-4.2,1.2c-1.1-0.3-2.2-0.7-3.4-1c0-9.7,0.1-19.4,0.1-29.1c1.1,0.1,2.2,0.2,3.3,0.3 c1.5-0.2,3-0.3,4.5-0.5C154.4,52.4,154.3,62.1,154.2,71.8z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Lag_5"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1al",
    d: "M104.6,63.4c-8.1,18.2-16.2,36.5-24.4,54.7c-1.5,5.2-5.5,21.8,3.5,31.9c0.7,0.8,1.4,1.5,2.3,2.2 c2,0.5,4,1.1,6.1,1.6c5.3,9.8,10.7,17.2,14.7,22.4c9.5,12.2,18.1,23,32.7,28.1c4.4,1.5,8.1,2.2,10.6,2.5 c0-44.6-0.1-89.2-0.1-133.8c-3.6-2.9-11.3-8.4-22.7-10.5C117.2,60.6,109,62.2,104.6,63.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3al",
    d: "M219.2,117.5C209.8,98.3,200.4,79.1,191,60c-4-0.8-11.6-1.7-20.5,0.8c-10.8,3-17.6,9.2-20.5,12.2 c0,44.6,0,89.2,0,133.8c2.1-0.1,5.2-0.4,8.9-1.3c14.9-3.8,24-14.7,33.3-26.2c4.5-5.6,10.4-13.7,16-24.3c2.8-0.4,4.9-1.4,6.4-2.5 C222.4,147.1,224.1,133,219.2,117.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4al",
    d: "M101.8,237c-1.8,11.6-5,21.4-8.3,29.1c-1.2,2.8-1.1,5.7,0.4,7.3c2.1,2.2,7.5,2,11-2.4 c3.1-4.4,6.2-8.8,9.4-13.2c3.5-3.8,8.4-9.8,12.1-18.4c3.8-8.7,4.9-16.8,5.1-22.5l-28.5,8.3C102.8,228.9,102.5,232.9,101.8,237z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2al",
    d: "M83.1,177.4c4.2,6.7,8.5,14.7,12.5,23.9c3.3,7.6,5.7,14.7,7.6,21.1c0,0.9-0.1,1.8-0.1,2.8l28.5-8.3 c0.1-1.4,0.1-2.7,0.1-3.8c-0.6-6.9-1.2-13.9-1.7-20.8c-3-1.6-6.5-3.7-10.1-6.6c-1.1-0.9-2.1-1.7-3-2.6L83.1,177.4 C83.1,177.3,83.1,177.4,83.1,177.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2al",
    d: "M74.1,126.1c-0.1,6.1,0.3,11.8,0.9,17.2l27.9,17.7c-3.4-10.8-6.4-24.6-6.3-40.2l-21-13.8 C74.7,112.9,74.1,119.2,74.1,126.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2al",
    d: "M126.3,35.8c-2.4-1.6-20.4-13.3-25.5-8.5c-1.1,1.1-1.6,4.3-2.6,10.7c-0.6,4.1-1,7.5-1.2,10.1 c-2.7,3.7-5.8,8.5-8.5,14.4s-4.4,11.3-5.4,15.8c-1.2,3.2-2.5,7.1-3.8,11.4l18.7,13c0.1-0.6,0.2-1.3,0.3-1.9 c1.2-6.7,2.9-12.9,4.9-18.4c1.8-2.3,3.7-4.2,5.6-5.6c15.3-11.8,37-5.2,41.2-3.8V43.2c-2.9-0.2-6.4-0.7-10.2-1.7 C134.1,39.9,129.5,37.7,126.3,35.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4al",
    d: "M75.6,107l20.9,13.7c0-5.8,0.5-11.8,1.5-18L79.3,89.6C77.9,94.7,76.6,100.6,75.6,107z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4al",
    d: "M83.1,177.3l33.7,5.8c-4.8-4.3-8.2-8.7-10.5-12.3c-1.2-2.9-2.4-6.2-3.5-9.8l-27.9-17.7 C76.5,157.7,80.1,169.4,83.1,177.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5al",
    d: "M93.5,49.9c-2.5,5.2-3.2,10-3.5,13.3c2.6-3.2,5.7-7.8,8.3-13.7c2.8-6.2,4.1-11.9,4.8-16.1 c2.2,2.4,5.3,5.3,9.6,7.8c2.5,1.5,4.8,2.5,6.9,3.3c-0.8-3-1.6-6.1-2.3-9.1c1.4,1.2,3.7,2.9,6.9,4c2.3,0.8,4.4,1.1,6,1.2 c-3.6-3.4-7.2-6.8-10.8-10.3c-2.2-1.7-8.8-6.3-16.4-4.8c-0.9,0.2-1.9,0.5-3,0.9c-0.3,0.4-0.8,1.2-1.3,2.2 c-2.7,5.5-0.3,9.5-2,15.3C96,46.5,95.3,46.1,93.5,49.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4al",
    d: "M198.2,237c1.8,11.6,5,21.4,8.3,29.1c1.2,2.8,1.1,5.7-0.4,7.3c-2.1,2.2-7.5,2-11-2.4 c-3.1-4.4-6.2-8.8-9.4-13.2c-3.5-3.8-8.4-9.8-12.1-18.4c-3.8-8.7-4.9-16.8-5.1-22.5l28.5,8.3C197.2,228.9,197.5,232.9,198.2,237z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2al",
    d: "M216.9,177.4c-4.2,6.7-8.5,14.7-12.5,23.9c-3.3,7.6-5.7,14.7-7.6,21.1c0,0.9,0.1,1.8,0.1,2.8l-28.5-8.3 c-0.1-1.4-0.1-2.7-0.1-3.8c0.6-6.9,1.2-13.9,1.7-20.8c3-1.6,6.5-3.7,10.1-6.6c1.1-0.9,2.1-1.7,3-2.6L216.9,177.4 C216.9,177.3,216.9,177.4,216.9,177.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2al",
    d: "M225.9,126.1c0.1,6.1-0.3,11.8-0.9,17.2L197.2,161c3.4-10.8,6.4-24.6,6.3-40.2l20.9-13.7 C225.3,112.9,225.9,119.2,225.9,126.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2al",
    d: "M173.7,35.8c2.4-1.6,20.4-13.3,25.5-8.5c1.1,1.1,1.6,4.3,2.6,10.7c0.6,4.1,1,7.5,1.2,10.1 c2.7,3.7,5.8,8.5,8.5,14.4s4.4,11.3,5.4,15.8c1.2,3.2,2.5,7.1,3.8,11.4l-18.7,13c-0.1-0.6-0.2-1.3-0.3-1.9 c-1.2-6.7-2.9-12.9-4.9-18.4c-1.8-2.3-3.7-4.2-5.6-5.6c-15.3-11.8-37-5.2-41.2-3.8V43.2c2.9-0.2,6.4-0.7,10.2-1.7 C165.9,39.9,170.5,37.7,173.7,35.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4al",
    d: "M224.4,107l-20.9,13.7c0-5.8-0.5-11.8-1.5-18l18.7-13.1C222.1,94.7,223.4,100.6,224.4,107z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4al",
    d: "M216.9,177.3l-33.7,5.8c4.8-4.3,8.2-8.7,10.5-12.3c1.2-2.9,2.4-6.2,3.5-9.8l27.9-17.7 C223.5,157.7,219.9,169.4,216.9,177.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5al",
    d: "M206.5,49.9c2.5,5.2,3.2,10,3.5,13.3c-2.6-3.2-5.7-7.8-8.3-13.7c-2.8-6.2-4.1-11.9-4.8-16.1 c-2.2,2.4-5.3,5.3-9.6,7.8c-2.5,1.5-4.8,2.5-6.9,3.3c0.8-3,1.6-6.1,2.3-9.1c-1.4,1.2-3.7,2.9-6.9,4c-2.3,0.8-4.4,1.1-6,1.2 c3.6-3.4,7.2-6.8,10.8-10.3c2.2-1.7,8.8-6.3,16.4-4.8c0.9,0.2,1.9,0.5,3,0.9c0.3,0.4,0.8,1.2,1.3,2.2c2.7,5.5,0.3,9.5,2,15.3 C204,46.5,204.7,46.1,206.5,49.9z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 80.3,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -23.0099 117.333)",
    className: "st2al",
    width: 12.2,
    height: 12.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.2,
    y: 80.3,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -11.8217 144.3444)",
    className: "st2al",
    width: 12.2,
    height: 12.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2al",
    d: "M113.4,145.2c1.8,2.1,4.8,5.1,9.2,7.5c2.8,1.5,5.4,2.4,7.5,2.9c-1,2.2-3,7.2-2.4,13.7c0.5,5.7,2.7,9.9,4,12 c-1.9-0.9-5.5-2.8-8.7-6.8c-3.4-4.3-4.4-8.7-4.7-10.7c1.1-1.2,2.2-2.3,3.3-3.5c-1.3-0.6-3.4-1.9-5.2-4.2 C112.8,151.6,113.2,146.4,113.4,145.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2al",
    d: "M186.6,145.2c-1.8,2.1-4.8,5.1-9.2,7.5c-2.8,1.5-5.4,2.4-7.5,2.9c1,2.2,3,7.2,2.4,13.7c-0.5,5.7-2.7,9.9-4,12 c1.9-0.9,5.5-2.8,8.7-6.8c3.4-4.3,4.4-8.7,4.7-10.7c-1.1-1.2-2.2-2.3-3.3-3.5c1.3-0.6,3.4-1.9,5.2-4.2 C187.1,151.6,186.7,146.4,186.6,145.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2al",
    d: "M142.1,79.9c1.2,0,2.4,0,3.6,0c0.5,3.5,1.1,7,1.6,10.5c-1.2,2-2.5,4.1-3.7,6.1c1.3,1.7,2.7,3.5,4,5.2 c-1,4.8-2.1,9.6-3.1,14.4c-14.4-9.6-29.4-9.4-35.7-2.3c-1.1,1.3-3.7,4.7-3.6,11.6c-0.6-2.9-1.7-10.1,2.3-15.5 c5.9-7.8,21.2-9.5,35.2-0.3c0.7-2.5,1.5-5,2.2-7.5c-2.1-1.7-4.3-3.5-6.4-5.2c1.9-2.2,3.9-4.4,5.8-6.6 C143.6,86.9,142.9,83.4,142.1,79.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2al",
    d: "M158.2,79.9c-1.2,0-2.4,0-3.6,0c-0.5,3.5-1.1,7-1.6,10.5c1.2,2,2.5,4.1,3.7,6.1c-1.3,1.7-2.7,3.5-4,5.2 c1,4.8,2.1,9.6,3.1,14.4c14.4-9.6,29.4-9.4,35.7-2.3c1.1,1.3,3.7,4.7,3.6,11.6c0.6-2.9,1.7-10.1-2.3-15.5 c-5.9-7.8-21.2-9.5-35.2-0.3c-0.7-2.5-1.5-5-2.2-7.5c2.1-1.7,4.3-3.5,6.4-5.2c-1.9-2.2-3.9-4.4-5.8-6.6 C156.7,86.9,157.4,83.4,158.2,79.9z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Lag_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6al",
    d: "M67.7,184.8"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAhsokaLogo);
export default __webpack_public_path__ + "static/media/ahsoka-logo.67d0102c.svg";
export { ForwardRef as ReactComponent };